import React from "react";
import ContentPasteGoIcon from "@mui/icons-material/ContentPasteGo";
import FlowActionButton from "@components/FlowActionButtons/FlowActionButton";

interface ClaimButtonProps {
  langBase: string;
  permission: string | string[];
  isActionAvailable: boolean;
  onClaim: () => void;
}

const ClaimButton: React.FC<ClaimButtonProps> = ({
  langBase,
  permission,
  isActionAvailable,
  onClaim,
}) => {
  return (
    <FlowActionButton
      langBase={langBase}
      permission={permission}
      isActionAvailable={isActionAvailable}
      labelKey="claim-button"
      testId="claim"
      variant="contained"
      startIcon={<ContentPasteGoIcon />}
      onClick={onClaim}
    />
  );
};

export default ClaimButton;
